<template>
  <div>
    <div
      v-if="showMultipleSets()"
      class="align-items-horizontally"
    >
      <div
        v-for="(set, setIndex) in datasets"
        :key="setIndex"
        class="legend"
      >
        <div
          class="legend__item"
          :class="{'item-line-through' : lineThrough[setIndex].item}"
          @click="clicked(setIndex)"
        >
          <div
            class="legend__item__box"
            :class="averageLine === true ? 'average' : ''"
            :style="legendColor(setIndex)"
          />

          <div class="legend__item__text">
            {{ datasets[setIndex].label }}
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div
        v-for="(set, setIndex) in datasets"
        :key="setIndex"
        class="legend"
      >
        <div
          v-for="(item, labelIndex) in labels"
          :key="labelIndex"
          class="legend__item"
          :class="{'item-line-through' : lineThrough[labelIndex].item}"
          @click="clicked(setIndex, labelIndex)"
        >
          <div
            class="legend__item__box"
            :style="legendColor(setIndex, labelIndex)"
          />

          <div class="legend__item__text">
            {{ item }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ChartLegend',
    props: {
      datasets: {
        type: Array,
        required: true,
        validator: (datasets) => {
          return (
            Array.isArray(datasets) &&
            datasets.length > 0
          )
        }
      },
      labels: {
        type: Array,
        required: false,
        default: () => []
      },
      averageLine: {
        type: Boolean,
        required: false,
        default: false
      }
    },
    data () {
      return {
        lineThrough: [{ item: false }, { item: false }]
      }
    },
    methods: {
      showMultipleSets () {
        return this.datasets.length > 1 || this.averageLine === true
      },
      legendColor (setIndex, labelIndex) {
        if (this.showMultipleSets()) {
          return `background: ${this.datasets[setIndex].backgroundColor};`
        } else {
          return `background: ${this.datasets[setIndex].backgroundColor[labelIndex]};`
        }
      },
      clicked (setIndex, labelIndex) {
        if (this.showMultipleSets()) {
          this.$emit('clicked', { setIndex: setIndex })
          this.lineThrough[setIndex].item = !this.lineThrough[setIndex].item
        } else {
          this.$emit('clicked', { setIndex: setIndex, labelIndex: labelIndex })
          this.lineThrough[labelIndex].item = !this.lineThrough[labelIndex].item
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .legend {
    margin-top: rhythm();
    justify-content: center;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    cursor: pointer;

    &__item {
      display: flex;
      align-items: center;

      &__box {
        width: rhythm('medium');
        height: rhythm('half');
        margin: 0 rhythm('xsmall');

        &.average {
          height: rem(2px);
        }
      }
    }
  }

  .item-line-through {
    text-decoration: line-through;
  }

  .align-items-horizontally {
    text-align: center;
  }

  .align-items-horizontally .legend {
    display: inline-block;

    /* IE fix. */
    *display: inline;
    zoom: 1;
  }

  .align-items-horizontally::after {
    content: '';
    width: 100%;
    display: inline-block;
  }
</style>
